import { createElement } from 'react';
import { ListProps } from '.';
import { ListContextProvider } from './__internal__/';
import { BaseList } from './__internal__/BaseList';

import './List.css';

/**
 * The List component provides a layout grid of list items.
 *
 * @component
 * @param {ListProps} props the ListProps properties
 * @returns the List element
 */
export const List = (props: ListProps) => {
  return (
    <ListContextProvider>
      <BaseList {...props} />
    </ListContextProvider>
  );
};
